import { makeStyles } from "@material-ui/core";

const useGoogleStyles = makeStyles(theme => ({
    customGoogle: {
      maxWidth: '100%',
      color: '#ffffff',
      height: '48px',
      alignSelf: 'center',
      backgroundColor: '#1d273c',
      borderRadius: '100px',
      fontSize: '16px',
      fontWeight: 700,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      pointerEvents: 'none',
      minWidth: '100%',
      position: 'absolute',
      zIndex: 2,
      [theme.breakpoints.down('md')]: { // Media query
        height: '48px',
        borderRadius: '100px',
      },
    },
    googleLoginContainer: {
      zIndex: 2,
      position: 'relative',
      transition: 'opacity 0.2s ease',
      "&:hover": {
        opacity: 0.5,
      },
      [theme.breakpoints.down('md')]: { // Media query
        marginTop: '5px',
      },
    },
  }));

  export default useGoogleStyles